import React, { forwardRef, useState, useEffect } from 'react'
import { castArray, keys } from 'lodash-es'
import { Select, SelectComponents as components } from '@ow/comps'
import { photoBgColor } from '@ow/utils'
import { useDitto } from '@ow/ditto-core'
import { multiSelectStyles, singleSelectStyles } from './style'
import closeImg from './assets/close.png'
import downImg from './assets/up.png'
import upImg from './assets/down.png'

const MultiValueRemove = (props) => {
  return (
    <components.MultiValueRemove {...props}>
      <img
        src={closeImg}
        alt=""
        style={{ width: '.875rem', height: '.875rem' }}
      />
    </components.MultiValueRemove>
  )
}

const MultiValueLabel = (props) => {
  const { data } = props
  return (
    <components.MultiValueLabel {...props}>
      <span style={{ fontSize: '.8125rem' }}>{data.title}</span>
    </components.MultiValueLabel>
  )
}

// 删除所有
const ClearIndicator = (props) => {
  return (
    <components.MultiValueLabel {...props}>
      <img
        className="ml-3"
        src={closeImg}
        alt=""
        style={{ width: '.875rem', height: '.875rem' }}
      />
    </components.MultiValueLabel>
  )
}

const DropdownIndicator = (props) => {
  const { isFocused } = props
  return (
    <components.DropdownIndicator {...props}>
      <img
        className="ml-3"
        src={isFocused ? downImg : upImg}
        alt=""
        style={{ width: '.6875rem', height: '.375rem' }}
      />
    </components.DropdownIndicator>
  )
}
const renderOptions = (data) => {
  return (
    <div
      className="flex flex-row items-center cursor-pointer"
      style={{
        borderRadius: '1rem',
        padding: '0.125rem',
        color: '#262626',
        background: 'rgba(38,38,38,.1)',
        fontSize: '0.8125rem',
      }}
    >
      {data.photo ? (
        <img className="rounded-full w-5 h-5" alt="" src={data.photo} />
      ) : (
        <div
          className="rounded-full flex items-center justify-center text-white w-5 h-5"
          style={{ background: photoBgColor(data.id), minWidth: '20px' }}
        >
          {data.name ? data.name[0] : ''}
        </div>
      )}
      <span className="px-1.5 whitespace-nowrap truncate">
        {data.name + '-' + data.mobile}
      </span>
    </div>
  )
}
const Option = (props) => {
  const { data } = props
  return <components.Option {...props}>{renderOptions(data)}</components.Option>
}

const Render = function ({ opts = {}, widgets = {}, onChange, value }, ref) {
  const { onFetchRemoteData } = useDitto()
  const {
    remote: finalRemote = {},
    type,
    readonly,
    slug,
    inline,
    selects: customSelects,
    showConditions,
  } = opts

  console.log(opts, 'optsoptsoptsopts')
  const multiple = type === 'userMultiple'
  const [users, setUsers] = useState([])
  console.log(users, 'usersusersusersusers')

  const props = {}
  if (multiple) {
    props.components = {
      MultiValueLabel,
      MultiValueRemove,
      ClearIndicator,
      DropdownIndicator,
      Option,
    }
    props.isMulti = true
    props.isClearable = true
    props.styles = multiSelectStyles({ width: '100%', height: 'unset' })
  } else {
    props.components = {
      MultiValueLabel,
      MultiValueRemove,
      ClearIndicator,
      DropdownIndicator,
      Option,
    }
    props.isClearable = false
    props.styles = singleSelectStyles({ width: '100%', height: 'unset' })
  }

  const onUserChange = (user) => {
    if (multiple) {
      // const obj = user[user.length - 1]
      // onChange(value ? value.concat([obj.id]) : [obj.id])
      onChange((user || []).map((item) => item.id))
    } else {
      onChange(user && user.id)
    }
  }

  const filterByCondition = (arr) => {
    return arr.filter((item) => {
      return keys(showConditions).every((v) => item[v] === showConditions[v])
    })
  }

  const commomApi = () => {
    const user = onFetchRemoteData('user')
    user.fetchTreeData().then((data = []) => {
      setUsers(
        filterByCondition(
          data
            .filter((f) => f.active)
            .map((v) => {
              return { ...v, title: v.name }
            })
        )
      )
    })
  }

  useEffect(() => {
    if (inline) return

    if (onFetchRemoteData) {
      // 如果配置了api,走extend请求定制接口
      if (finalRemote.api) {
        const extend = onFetchRemoteData('extend')

        extend[finalRemote.api](finalRemote.url, finalRemote.opts).then(
          (res) => {
            const { defaultValue, orgs: selects } = res
            const finalDefaultValue =
              defaultValue || (res[slug] && res[slug].defaultValue)

            if (selects) {
              setUsers(
                filterByCondition(
                  (selects || []).map((option) => {
                    return { ...option, label: option.title }
                  })
                )
              )
            } else if (res[slug] && res[slug].selects) {
              setUsers(
                filterByCondition(
                  res[slug].selects.map((option) => {
                    return { ...option, label: option.title }
                  })
                )
              )
            } else {
              commomApi()
            }
            if (onChange && finalDefaultValue) {
              onChange(
                type === 'userMultiple'
                  ? castArray(finalDefaultValue)
                  : finalDefaultValue
              )
            }
          }
        )
      } else if (customSelects) {
        setUsers(
          filterByCondition(
            (customSelects || []).map((option) => {
              return { ...option, label: option.title }
            })
          )
        )
      } else {
        commomApi()
      }
    }
  }, [])

  const _value = (value && castArray(value)) || []

  if (inline) {
    const Widget = widgets.users
    return <Widget value={_value} onChange={onChange} />
  }

  return (
    <div className="w-full">
      <Select
        ref={ref}
        options={users || []}
        value={users
          .filter((v) => _value.includes(v.id))
          .map((item) => {
            return { ...item, value: item.id }
          })}
        formatOptionLabel={(v) => {
          return renderOptions(v)
        }}
        isDisabled={readonly}
        hideSelectedOptions={false}
        placeholder={opts.hint || `请选择${opts.title}`}
        clearable
        noOptionsMessage={() => {
          return '暂无数据'
        }}
        filterOption={(option, inputValue) => {
          try {
            return (
              (option.data.title &&
                option.data.title.indexOf(inputValue) > -1) ||
              (option.data.mobile &&
                option.data.mobile.indexOf(inputValue) > -1) ||
              (option.data.name && option.data.name.indexOf(inputValue) > -1)
            )
          } catch (error) {
            return true
          }
        }}
        onChange={onUserChange}
        {...props}
      />
    </div>
  )
}

export default forwardRef(Render)
